// --- Global Category System Matrix ---
export const CATEGORIES = [
  "All Products",
  "Nuts & Bolts",
  "Washers",
  "Screws",
  "Springs",
  "Axles",
  "Brake Parts",
  "Sprockets",
  "Spare Parts"
];

// --- Structural Production Inventory Database ---
const PRODUCTS_INVENTORY = [
  {
    id: 1,
    name: "Allen Bolts",
    image: "Allen Bolts.png",
    category: "Nuts & Bolts",
    meta: "High-Tensile Hex Socket Head Bolts"
  },
  {
    id: 2,
    name: "Axle Nuts",
    image: "Axle Nuts.png",
    category: "Nuts & Bolts",
    meta: "Heavy Duty Locking Rear & Front Axle Nuts"
  },
  {
    id: 3,
    name: "Beeding & Nose Screws",
    image: "Beeding & Nose Screws.png",
    category: "Screws",
    meta: "Precision Self-Tapping Bodywork Screws"
  },
  {
    id: 4,
    name: "Brake & Clutch Lever Fastener Set",
    image: "Brake & Clutch Lever Nut Bolt Washer.png",
    category: "Brake Parts",
    meta: "Pivot Bolt Assemblies for Handlebar Controls"
  },
  {
    id: 5,
    name: "Brake Cam & Lever Set",
    image: "Brake Cam & Lever Set.png",
    category: "Brake Parts",
    meta: "Actuating Camshaft and Control Arm Mechanism",
    badge: "HOT"
  },
  {
    id: 6,
    name: "Brake Drum Plate Fastener Set",
    image: "Brake Drum Plate Nut Bolt Washer.png",
    category: "Brake Parts",
    meta: "Torque Arm & Anchor Plate Anchor Fasteners"
  },
  {
    id: 7,
    name: "Center Stand Pin",
    image: "Center Stand Pin.png",
    category: "Nuts & Bolts",
    meta: "Hardened Main Pivot Pin with Cotter Pin Groove"
  },
  {
    id: 8,
    name: "Chain Adjuster Set",
    image: "Chain Adjuster Set.png",
    category: "Nuts & Bolts",
    meta: "Swingarm Wheel Alignment Tensioner Bolt Kit",
    badge: "POPULAR"
  },
  {
    id: 9,
    name: "Clutch Nuts",
    image: "Clutch Nuts.png",
    category: "Nuts & Bolts",
    meta: "Center Hub Retaining Spanner Lock Nuts"
  },
  {
    id: 10,
    name: "Gear Lever Assembly",
    image: "Gear Lever Assembly.png",
    category: "Brake Parts",
    meta: "Foot Shifter Linkage Selector & Pivot Mechanism"
  },
  {
    id: 11,
    name: "Gearbox Sprocket",
    image: "Gearbox Sprocket.png",
    category: "Sprockets",
    meta: "Countershaft Front Drive Sprocket Locking Assembly"
  },
  {
    id: 12,
    name: "General Nut Bolt Washer Kit",
    image: "General Nut Bolt Washer.png",
    category: "Nuts & Bolts",
    meta: "Standard Grade Metric Structural Maintenance Pack"
  },
  {
    id: 13,
    name: "Head Light Adjusting Bolt",
    image: "Head Light Adjusting Bolt.png",
    category: "Nuts & Bolts",
    meta: "Fine-Thread Beam Alignment Screw with Tension Element"
  },
  {
    id: 14,
    name: "Head Light Visor & Fairing Screws",
    image: "Head Light Visor & Fairing Screws.png",
    category: "Screws",
    meta: "Black Oxide Finished Body Trim Panel Screws"
  },
  {
    id: 15,
    name: "Kick Boss Assembly",
    image: "Kick Boss Assembly.png",
    category: "Nuts & Bolts",
    meta: "Kickstarter Lever Joint Spline Boss & Cotter Bolt"
  },
  {
    id: 16,
    name: "Oil Drain Bolts & Nuts",
    image: "Oil Drain Bolts & Nuts.png",
    category: "Nuts & Bolts",
    meta: "Magnetic Sump Plug with Copper Crush Washer",
    badge: "NEW"
  },
  {
    id: 17,
    name: "Plug Spanner",
    image: "Plug Spanner.png",
    category: "Nuts & Bolts",
    meta: "Hexagonal Spark Plug Deep Sunk Removal Socket Tool"
  },
  {
    id: 18,
    name: "Seat Fixing Bracket & Catcher",
    image: "Seat Fixing Bracket & Catcher.png",
    category: "Nuts & Bolts",
    meta: "Mounting Subframe Lock Hook & Brackets"
  },
  {
    id: 19,
    name: "Split Pins Set",
    image: "Split Pins.png",
    category: "Nuts & Bolts",
    meta: "Zinc Plated Heavy Duty Steel Cotter Pins"
  },
  {
    id: 20,
    name: "Mechanical Return Springs Pack",
    image: "Springs for Brake Pedal, Side Stand, Center Stand, Brake Shoe, Clutch Return.png",
    category: "Springs",
    meta: "High Elastic Return Springs for Stands, Pedals & Shoes",
    badge: "BESTSELLER"
  },
  {
    id: 21,
    name: "Steel Washers",
    image: "Steel Washers.png",
    category: "Washers",
    meta: "Flat & Split Lock Metric Sealing Washers"
  },
  {
    id: 22,
    name: "Visor & Nose Clips (Type Alpha)",
    image: "Visor & Nose Clips.png",
    category: "Screws",
    meta: "Threaded U-Nut Speed Fastener Clips for Fairings"
  },
  {
    id: 23,
    name: "Visor & Nose Clips (Type Beta)",
    image: "Visor & Nose Clips.png",
    category: "Screws",
    meta: "Snap-on Automotive Bodywork Spring Trim Clips"
  },
  {
    id: 24,
    name: "Wheel Axles",
    image: "Wheel Axles.png",
    category: "Axles",
    meta: "High-Tensile Solid Steel Front & Rear Shaft Spindles",
    badge: "PREMIUM"
  },

  // ── NEW PRODUCTS ──
  {
    id: 25,
    name: "Chain Adjuster for Royal Enfield Bullet Meteor",
    image: "Chain Adjuster for Royal Enfield Bullet Meteor.png",
    category: "Spare Parts",
    meta: "OEM-Spec Swingarm Chain Tensioner for RE Meteor",
    badge: "NEW"
  },
  {
    id: 26,
    name: "Chassis & Body Fasteners Kit — RE Bullet Classic",
    image: "Chhasis and Body Fasteners Kit Complete  Royal Enfield Bullet Classic.png",
    category: "Nuts & Bolts",
    meta: "Complete Frame & Bodywork Fastener Kit for RE Classic",
    badge: "NEW"
  },
  {
    id: 27,
    name: "Crown Plate Nut Bolt for Bullet",
    image: "Crown Plate Nut Bolt for  Bullet.png",
    category: "Nuts & Bolts",
    meta: "Top Yoke Stem Nut & Bolt Set for Royal Enfield Bullet"
  },
  {
    id: 28,
    name: "Footrest Assembly",
    image: "Footrest Assembly.png",
    category: "Spare Parts",
    meta: "Rider & Pillion Footpeg Bracket Assembly with Fasteners"
  },
  {
    id: 29,
    name: "Fork Cage Bearing Balls Set (HCHC)",
    image: "Fork Cage Bearing Balls Set (HCHC).png",
    category: "Spare Parts",
    meta: "High Carbon Chrome Steel Steering Head Bearing Ball Set",
    badge: "PREMIUM"
  },
  {
    id: 30,
    name: "Front Sprocket Kit",
    image: "Front Sprocket Kit.png",
    category: "Sprockets",
    meta: "Countershaft Drive Sprocket Kit with Locking Washer",
    badge: "HOT"
  },
  {
    id: 31,
    name: "Photo",
    image: "Photo.png",
    category: "Spare Parts",
    meta: "Precision Automotive Component"
  },
  {
    id: 32,
    name: "Rear Axle Assembly — Royal Enfield Bullet",
    image: "Rear Axle Assembly  Royal Enfield Bullet.png",
    category: "Axles",
    meta: "Complete Rear Wheel Axle Shaft Assembly for RE Bullet",
    badge: "NEW"
  },
  {
    id: 33,
    name: "Rear Shocker Nut Bolt for Bullet",
    image: "Rear Shocker Nut Bolt for Bullet.png",
    category: "Nuts & Bolts",
    meta: "Rear Suspension Mounting Nut & Bolt Set for RE Bullet"
  },
  {
    id: 34,
    name: "Rear Sprocket Kit",
    image: "Rear Sprocket Kit.png",
    category: "Sprockets",
    meta: "Rear Wheel Drive Sprocket with Mounting Hardware",
    badge: "POPULAR"
  },
  {
    id: 35,
    name: "Rear Sprocket Kit (Variant 2)",
    image: "Rear Sprocket Kit (2).png",
    category: "Sprockets",
    meta: "Heavy-Duty Rear Sprocket Kit — Alternate Tooth Profile"
  },
  {
    id: 36,
    name: "Shocker Nut Bolt & Washer — Splendor",
    image: "Shocker Nut Bolt & Washer (Weldable)  Splendor.png",
    category: "Nuts & Bolts",
    meta: "Weldable Shock Absorber Mounting Set for Hero Splendor"
  },
  {
    id: 37,
    name: "Shocker Tube Allen Bolt for Bullet UCE",
    image: "Shocker Tube Allen Bolt  for Bullet UCE.png",
    category: "Nuts & Bolts",
    meta: "Fork Leg Allen Bolt for Royal Enfield UCE Engine Models"
  },
  {
    id: 38,
    name: "Side Stand Bolt & Nut — RE Bullet Classic",
    image: "Side Stand Bolt & Nut  Royal Enfield Bullet Classic.png",
    category: "Spare Parts",
    meta: "Pivot Bolt & Lock Nut Set for RE Bullet Classic Side Stand"
  },
  {
    id: 39,
    name: "Side Stand Bolt & Pivot — RE Classic Reborn",
    image: "Side Stand Bolt & Pivot  Royal Enfield Classic Reborn.png",
    category: "Spare Parts",
    meta: "Side Stand Pivot Pin & Bolt for Royal Enfield Classic Reborn",
    badge: "NEW"
  },
  {
    id: 40,
    name: "Speedometer Nuts",
    image: "Speedometer Nuts.png",
    category: "Nuts & Bolts",
    meta: "Instrument Cluster & Cable Drive Retaining Nuts"
  },
  {
    id: 41,
    name: "Wheel Spacers",
    image: "Wheel Spacers.png",
    category: "Axles",
    meta: "Precision Machined Aluminium & Steel Wheel Hub Spacers"
  }
];

/**
 * Retrieves catalog items with support for structural category filters.
 * @param {string} category - Category filter configuration token.
 * @returns {Array} Filtered list of functional components.
 */
export function getProducts(category = "All Products") {
  if (!category || category === "All Products") {
    return [...PRODUCTS_INVENTORY];
  }
  return PRODUCTS_INVENTORY.filter(product => product.category === category);
}

/**
 * Retrieves a single complete product match tracking token.
 * @param {number} id - Product item identifier.
 * @returns {Object|undefined} Matched product dataset entity.
 */
export function getProductById(id) {
  return PRODUCTS_INVENTORY.find(product => product.id === Number(id));
}